import { Dialog, DialogProps, DialogTitle } from "@mui/material";
import { FC } from "react";
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import { IAddDialogProps } from "./models/addDialogProps";
import CloseButton from "../UI/CloseButton/closeButton";

const AddDialog: FC<IAddDialogProps> = ({ onClose, open, title, maxWidth, children, titleIcon, ...props }) => {

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth {...props}>
            <DialogTitle id="alert-dialog-title" justifyContent='flex-start' alignItems='center' display='flex' borderBottom={1} borderColor='#e6e6e6' sx={{ fontSize: 14, padding: '8px 24px' }}>
                {titleIcon || <DynamicFormIcon color="primary" sx={{ marginRight: 1 }} />}
                {title}
                <span style={{ marginRight: 'auto' }}>
                    <CloseButton onClick={onClose} />
                </span>
            </DialogTitle>
            {children}
        </Dialog>
    )
}

export default AddDialog;